import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Global GSAP defaults — smooth, cinematic feel
gsap.defaults({ ease: 'power2.out', duration: 1 });

// ScrollTrigger defaults
ScrollTrigger.defaults({
  invalidateOnRefresh: true,
  refreshPriority: -1,
});

export { gsap, ScrollTrigger };
